import * as api from '../../../clients/api';

import {Action} from '@ngrx/store';

export const GET_IDENTITY = '[ApiModul] GetIdentity laden';
export const GET_IDENTITY_AUSFUEHREN = '[ApiModul] GetIdentity ausführen';
export const GET_IDENTITY_ERFOLGREICH = '[ApiModul] GetIdentity laden erfolgreich';
export const GET_IDENTITY_FEHLER = '[ApiModul] GetIdentity Ladefehler';
export const GET_IDENTITY_NICHT_AUSGEFUEHRT = '[ApiModul] GetIdentity nicht ausgeführt (evtl. Offline)';


export class GetIdentityAction implements Action {
    readonly type = GET_IDENTITY;
        constructor(public optPayload: any = null) {}
    }
export class GetIdentityAusfuehrenAction implements Action {
    readonly type = GET_IDENTITY_AUSFUEHREN;
        constructor(public optPayload: any = null) {}
    }
export class GetIdentityErfolgreichAction implements Action {
    readonly type = GET_IDENTITY_ERFOLGREICH;
        constructor(public payload: api.MyIdentity, public optPayload: any = null) {}
    }
export class GetIdentityFehlerAction implements Action {
    readonly type = GET_IDENTITY_FEHLER;
        constructor(public payload: any, public optPayload: any = null) {}
    }
export class GetIdentityNichtAusgefuehrtAction implements Action {
    readonly type = GET_IDENTITY_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type ApiQueryIdentityActions =
    GetIdentityAction
    | GetIdentityAusfuehrenAction
    | GetIdentityErfolgreichAction
    | GetIdentityFehlerAction
    | GetIdentityNichtAusgefuehrtAction
    ;
